import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { z } from 'zod'

import BusinessFormField from '../../components/business-form-field'
import BusinessFormTitle from '../../components/business-form-title'
import { useBusinessCreateContext } from '../../context/business-create-context'
import { useBusinessCreateStore } from '../../store/business-create-store'

const EmailSchema = z.object({
  email: z.string().email({ message: 'Invalid email address' }),
})
type EmailSchemaType = z.infer<typeof EmailSchema>

export default function BusinessCreateEmailStep() {
  const { setFormData, formData } = useBusinessCreateStore()
  const { handleNext, setFooterConfig } = useBusinessCreateContext()

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<EmailSchemaType>({
    resolver: zodResolver(EmailSchema),
    defaultValues: {
      email: formData.consumerEmail ?? '',
    },
  })

  const onSubmit = (data: EmailSchemaType) => {
    setFormData({ ...formData, consumerEmail: data.email })
    handleNext()
  }

  const emailValue = useWatch({
    control,
    name: 'email',
  })

  useEffect(() => {
    const hasEmail = !!emailValue?.trim()
    setFooterConfig({
      buttonText: hasEmail ? 'Continue' : 'Skip',
      buttonVariant: hasEmail ? 'default' : 'ghost',
      primaryAction: hasEmail ? undefined : () => handleNext(),
    })
  }, [emailValue, handleNext, setFooterConfig])

  return (
    <div className="flex size-full flex-col items-center justify-center gap-4">
      <BusinessFormTitle>{`What is ${formData.consumerFirstName || 'your client'}'s email?`}</BusinessFormTitle>
      <form id="business-create-form" onSubmit={handleSubmit(onSubmit)} className="w-full">
        <BusinessFormField
          register={register}
          placeholder="Email"
          name="email"
          type="text"
          error={errors.email}
          autoFocus={true}
        />
      </form>
    </div>
  )
}
